module.exports = "<li class=wh-insights-listing-filters__item> <a href=\"\" data-filter=\"<%=Type%>\" class=wh-insights-listing-filters__item-link data-search-type=\"<%=Type%>\" data-search-type-uuid=\"<%=ContentTypeId%>\" data-search-subtype-uuid=\"<%=ContentSubTypeIds%>\"> <%=TabDisplayName%> </a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/templates/insights-listing-tab.html
// module id = 605
// module chunks = 64